import { auth, df } from '@/plugins/firebase'
import state from '@/state'
import { dateTimeToUnixTimestamp } from '@/libs/receiptIssuing/commons'
import { v4 as uuidv4 } from 'uuid'

export const validateParamsForReceipt = (params) => {
  var response = {
    valid: true
  }

  if (params && params.items && params.items.length > 0) {
    var totalByItems = 0
    var itemBreakdown = []

    params.items.forEach(item => {
      response = checkAmount(item)
      if (response.valid === false) {
        logError(params, response)
        return response
      }

      totalByItems += item.price
      itemBreakdown.push({
        name: item.name,
        price: item.price,
        singlePrice: item.single_item_price,
        amount: item.amt,
        priceFormatted: (item.price / 100).toFixed(2),
        singlePriceFormatted: (item.single_item_price / 100).toFixed(2),
        amountFormatted: (item.amt / 100).toFixed(2)
      })
    })

    if (!params.discount || (params.discount && params.discount.name && params.discount.name !== 'Reprezentacija')) {
      const discountAmount = params.discount && params.discount.amount && params.discount.amount > 0 ? params.discount.amount : 0
      if (discountAmount > 0) {
        totalByItems -= discountAmount
      }

      response = checkPrices(totalByItems, params.total, itemBreakdown, discountAmount)
      if (response.valid === false) {
        logError(params, response)
        return response
      }
    }
  }

  return response
}

export const checkAmount = (item) => {
  var response = {
    valid: true
  }

  if (item.amt === 0 || item.amt < 0) {
    response = { valid: false, message: 'Artikl ' + item.name + ' ima krivu količinu. Molimo ispravite količinu artikla ili uklonite artikl i dodajte ga ponovno.' }
  }

  if (isNaN(item.amt)) {
    response = { valid: false, message: 'Artikl ' + item.name + ' ima krivu količinu. Molimo ispravite količinu artikla ili uklonite artikl i dodajte ga ponovno.' }
  }

  return response
}

export const checkPrices = (totalByItems, total, itemBreakdown = [], discountAmount = 0) => {
  var response = {
    valid: true
  }

  // Dozvoli toleranciju od 2 centa zbog zaokruživanja na item-level
  const difference = Math.abs(totalByItems - total)
  const ROUNDING_TOLERANCE = 2 // cents

  if (difference > ROUNDING_TOLERANCE) {
    const totalByItemsFormatted = (totalByItems / 100).toFixed(2)
    const totalFormatted = (total / 100).toFixed(2)
    const differenceFormatted = (difference / 100).toFixed(2)

    // Build item breakdown string
    let itemsDetail = '\nRaspored artikala:\n'
    let sumBeforeDiscount = 0
    itemBreakdown.forEach((item, index) => {
      itemsDetail += `  ${index + 1}. ${item.name}\n`
      itemsDetail += `      Količina: ${item.amountFormatted}\n`
      itemsDetail += `      Jedinična cijena: ${item.singlePriceFormatted} EUR\n`
      itemsDetail += `      Ukupno: ${item.priceFormatted} EUR\n`
      sumBeforeDiscount += item.price
    })
    itemsDetail += `  ------------------\n`
    itemsDetail += `  Zbroj: ${(sumBeforeDiscount / 100).toFixed(2)} EUR\n`

    if (discountAmount > 0) {
      itemsDetail += `  Popust: -${(discountAmount / 100).toFixed(2)} EUR\n`
      itemsDetail += `  ------------------\n`
      itemsDetail += `  Konačno: ${totalByItemsFormatted} EUR\n`
    }

    response = {
      valid: false,
      message: `Zbroj cijene artikala i ukupna cijena artikala se ne podudaraju.\n` +
               `${itemsDetail}\n` +
               `Očekivana ukupna cijena: ${totalFormatted} EUR\n` +
               `Razlika: ${differenceFormatted} EUR\n\n` +
               `Debug: totalByItems=${totalByItems} cents, total=${total} cents`
    }
  }

  return response
}

export const logError = (params, response) => {
  var userID = auth.currentUser.uid
  if (state.getCashRegisterUser().id !== undefined && state.getCashRegisterUser().id !== '') {
    userID = state.getCashRegisterUser().id
  }

  // Filter out undefined values from payload to prevent Firestore errors
  const sanitizeObject = (obj) => {
    if (obj === null || obj === undefined) return null
    if (typeof obj !== 'object') return obj
    if (Array.isArray(obj)) {
      return obj.map(item => sanitizeObject(item)).filter(item => item !== undefined)
    }
    const sanitized = {}
    Object.keys(obj).forEach(key => {
      const value = sanitizeObject(obj[key])
      if (value !== undefined) {
        sanitized[key] = value
      }
    })
    return sanitized
  }

  const sanitizedPayload = sanitizeObject(params)
  const errorMessage = response?.message || response?.error || 'Unknown error'

  df.doc(`error_logs/${uuidv4()}`)
    .set({
      user_id: userID,
      error: errorMessage,
      created: `${dateTimeToUnixTimestamp(new Date())}`,
      payload: sanitizedPayload
    })
    .catch(err => {
      console.error('Failed to log error to Firestore:', err)
    })

  return response
}

export const retry = async (fn, maxAttempts) => {
  const execute = async (attempt) => {
    try {
      return await fn()
    } catch (err) {
      if (attempt <= maxAttempts) {
        const nextAttempt = attempt + 1
        // const delayInSeconds = Math.max(Math.min(Math.pow(2, nextAttempt) +
        //   randInt(-nextAttempt, nextAttempt), 600), 1)
        const delayInSeconds = 2
        console.log(`Retrying after ${delayInSeconds} seconds due to:`, err)
        return delay(() => execute(nextAttempt), delayInSeconds * 1000)
      } else {
        throw err
      }
    }
  }
  return execute(1)
}

const delay = (fn, ms) => new Promise((resolve) => setTimeout(() => resolve(fn()), ms))

// const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)
